module.exports = __webpack_public_path__ + "static/media/HelveticaNeueLTStd-Md.ebf479f1.woff2";